<template>
  <v-container
    id="app-home"
    class="pa-1"
  >
    <v-card v-show="transactions.length > 0">
      <v-text-field
        v-model="search"
        label="Recherche transaction"
        class="mx-3 mb-3"
      />
    </v-card>
    <scrollable action>
      <v-card
        v-for="(transaction, i) in transactionsFiltered"
        :key="i"
        light
        class="mt-2"
        @click="choiceTransaction(transaction)"
      >
        <v-card-title>
          {{ transaction.ChampPriv }}
          <span class="ml-auto">
            {{ $amount(transaction.Montant) }}
          </span>
        </v-card-title>
        <v-card-subtitle>
          {{ transaction.Affichage }}
        </v-card-subtitle>
      </v-card>
    </scrollable>

    <template v-if="showRef">
      <amount />

      <v-card
        v-show="showRef"
        class="mt-2 pa-3"
      >
        <v-form @submit.prevent="validRef">
          <v-text-field
            ref="reference"
            v-model="ref"
            label="Référence transaction"
            :rules="[
              value => !!value || 'Une référence est requise',
              value => (value && value.length < 12) || 'La référence ne peut pas dépasser 12 caractères'
            ]"
            @input="onInput"
          />
        </v-form>
        <v-btn
          color="success"
          class="mt-3"
          block
          :disabled="ref.length < 3 || ref.length > 12"
          @click="validRef"
        >
          Valider
        </v-btn>
      </v-card>
    </template>

    <bottom-action
      btn-cancel
      btn-valid-disabled
      :btn-cancel-disabled="amount === 0"
      @cancel="$router.replace('/home')"
      @del="$router.replace({ name: 'home', params: { reset: false }})"
    />
  </v-container>
</template>

<script>
import { Operations } from '@/modules/Operations'
import { $alert, $amount } from '@/modules/Utils'
import Amount from '@/components/Amount.vue'

export default {
  name: 'TransactionW2S',

  components: {
    Amount
  },

  data () {
    return {
      search: '',
      transactions: [],
      //
      showRef: false,
      ref: ''
    }
  },

  computed: {
    amount () { return this.$store.state.amount },
    transactionsFiltered () {
      return this.transactions.filter(el => {
        return this.search === '' ||
          el.ChampPriv.includes(this.search.toLowerCase()) ||
          el.Affichage.includes(this.search.toLowerCase())
      })
    }
  },

  mounted () {
    if (this.$store.state.teleparameters === null) {
      this.$router.replace('/')
    } else {
      if (this.amount === 0) {
        Operations.getAllW2STransactions()
          .then((transactions) => {
            if (transactions.length === 0) {
              $alert('Aucune transaction W2S')
              this.$router.replace('/home')
            } else {
              this.transactions = transactions
            }
          })
          .catch(() => {
            this.$router.replace('/home')
          })
      } else {
        this.showRef = true
        setTimeout(() => {
          this.$refs.reference.focus()
        }, 200)
      }
    }
  },

  methods: {
    $amount,
    onInput (value) {
      if (value.length > 12 || !/^[a-zA-Z0-9]*$/.test(value)) {
        this.$nextTick(() => {
          this.ref = this.ref.substring(0, value.length - 1)
        })
      }
    },
    //
    choiceTransaction (transaction) {
      this.$store.commit('amount', Number(transaction.Montant))
      this.$router.replace({
        name: 'banking-payment',
        params: { idW2S: transaction.IDTransW2S }
      });
    },
    validRef () {
      this.$router.replace({
        name: 'banking-payment',
        params: { reference: this.ref }
      })
    }
  }
}
</script>
